export function getUserIdFromWindow() {
  return window.__DPL_CURRENT_USER_ID;
}
